<template>
  <LineChartGenerator
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :width="width"
    :height="height"
  />
</template>

<script>
import { Line as LineChartGenerator } from "vue-chartjs";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
  Filler,
} from "chart.js";
ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
  Filler
);

export default {
  name: "LineChart",
  components: {
    LineChartGenerator,
  },
  props: {
    chartId: {
      type: String,
      default: "line-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 400,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Array,
      default: () => [],
    },
    data1: {
      type: Array,
      default: () => [
        100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100,
        100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100,
        100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100,
        100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100,
        100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100,
        100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100,
        100, 100, 100, 100, 100, 100,
      ],
    },
    data2: {
      type: Array,
      default: () => [
        200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200,
        200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200,
        200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200,
        200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200,
        200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200,
        200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200,
        200, 200, 200, 200, 200, 200,
      ],
    },
  },
  computed: {
    chartData() {
      return {
        labels: [
          18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34,
          35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51,
          52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68,
          69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85,
          86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100,
        ],
        datasets: [
          {
            label: "運用をしない場合の積立額と取り崩し",
            backgroundColor: "rgba(252,231,204,1)",
            data: this.data1,
            fill: true,
            tension: 0,
          },
          {
            label: "運用をした場合の積立額と取り崩し",
            backgroundColor: "rgba(204,229,242,1)",
            data: this.data2,
            fill: true,
            tension: 0,
          },
        ],
      }; /* mutable chart data */
    },
  },
  data() {
    return {
      chartOptions: {
        responsive: true,
        maintainAspectRatio: true,
        aspectRatio: 1.81,
        pointStyle: "line",
        // pointBackgroundColor: "rgba(0,0,0,0)",
        // pointBorderColor: "rgba(0,0,0,0)",
        borderWidth: 0.5,
        scales: {
          x: {
            grid: {
              display: false,
            },
            ticks: {
              callback: function (value) {
                if (value == 0) {
                  return 18;
                }
                if ((value - 2) % 5 == 0) {
                  return value + 18;
                }
              },
            },
            title: {
              display: true,
              text: "（歳）",
              align: "end",
            },
          },

          y: {
            grid: {
              display: false,
            },
            ticks: {
              callback: function (value) {
                return value.toLocaleString() + "万円";
              },
            },
            min: 0,
            // max: 4500,
          },
        },
        plugins: {
          title: {
            display: true,
            text: `積立資金の推移`,
            position: "top",
            align: "start",
            font: {
              size: 14,
            },
          },
          tooltip: {
            mode: "nearest",
            intersect: false,
            enabled: true,
            callbacks: {
              title: () => {
                return ``;
              },
              label: (tooltipItem) => {
                console.log("tooltipItem:", tooltipItem);
                return `${tooltipItem.label}歳 : ${tooltipItem.raw}万円`;
              },
            },
            external: function (context) {
              // Tooltip Element
              let tooltipEl = document.getElementById("chartjs-tooltip");
              let chartWrap = document.getElementById("chart");

              // Create element on first render
              if (!tooltipEl) {
                tooltipEl = document.createElement("div");
                tooltipEl.id = "chartjs-tooltip";
                tooltipEl.innerHTML = "<div></div>";
                chartWrap.appendChild(tooltipEl);
              }
              console.log(context);
              // Hide if no tooltip
              const tooltipModel = context.tooltip;
              // if (tooltipModel.opacity === 0) {
              //   tooltipEl.style.opacity = 0;
              //   return;
              // }

              // Set caret Position
              // tooltipEl.classList.remove("above", "below", "no-transform");
              // if (tooltipModel.yAlign) {
              //   tooltipEl.classList.add(tooltipModel.yAlign);
              // } else {
              //   tooltipEl.classList.add("no-transform");
              // }

              // function getBody(bodyItem) {
              //   return bodyItem.lines;
              // }

              // Set Text
              // if (tooltipModel.body) {
              //   const titleLines = tooltipModel.title || [];
              //   const bodyLines = tooltipModel.body.map(getBody);

              //   let innerHtml = "<thead>";

              //   titleLines.forEach(function (title) {
              //     innerHtml += "<tr><th>" + title + "</th></tr>";
              //   });
              //   innerHtml += "</thead><tbody>";

              //   bodyLines.forEach(function (body, i) {
              //     const colors = tooltipModel.labelColors[i];
              //     let style = "background:" + colors.backgroundColor;
              //     style += "; border-color:" + colors.borderColor;
              //     style += "; border-width: 2px";
              //     const span = '<span style="' + style + '"></span>';
              //     innerHtml += "<tr><td>" + span + body + "</td></tr>";
              //   });
              //   innerHtml += "</tbody>";

              //   let tableRoot = tooltipEl.querySelector("table");
              //   tableRoot.innerHTML = innerHtml;
              // }

              const position = context.chart.canvas.getBoundingClientRect();
              const chartArea = context.chart.chartArea;
              // Display, position, and set styles for font
              tooltipEl.style.opacity = 1;
              tooltipEl.style.backgroundColor = "rgba(0, 0, 0, 0.1)";
              tooltipEl.style.height = chartArea.height + "px";
              tooltipEl.style.width = "1px";
              tooltipEl.style.position = "absolute";
              tooltipEl.style.left =
                position.left + window.pageXOffset + tooltipModel.caretX + "px";
              tooltipEl.style.top =
                chartArea.top + position.top + window.pageYOffset + "px";
              tooltipEl.style.padding = 0;
              // tooltipModel.padding + "px " + tooltipModel.padding + "px";
              tooltipEl.style.pointerEvents = "none";
            },
            backgroundColor: "#fff",
            bodyColor: "#666",
            bodySpacing: 5,
            borderColor: "rgba(0,0,0,0.1)",
            borderWidth: 1,
            caretSize: 0,
            caretPadding: 10,
          },
          legend: {
            position: "top",
            align: "end",
          },
        },
      },
    };
  },
  mounted: function () {},
};
</script>
